export const textarea = {
  root: {
    background: '{colors.transparent}',
    filledBackground: '{colors.transparent}',
    filledHoverBackground: '{colors.transparent}',
    filledFocusBackground: '{colors.transparent}',
  },
};
